// extracted by mini-css-extract-plugin
export default {"mainTitle":"_3kZkwPNOg0zve5aJ8ct2Vt"};